// StickyFooter.jsx
import React from "react";
import {
  Box,
  Container,
  Card,
  Stack,
  Typography,
  Button,
  CircularProgress,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { ArrowRight } from "lucide-react";

export const StickyFooter = ({
  estimatedPrice,
  onSubmit,
  canSubmit = false,
  submitting = false,
  priceLabel,
  submitLabel,
  submittingLabel,

  // ✅ NEW
  selectedTransportLabel,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { t } = useTranslation();

  const finalPriceLabel = priceLabel || t("delivery.estimate");
  const finalSubmitLabel = submitLabel || t("delivery.create");
  const finalSubmittingLabel = submittingLabel || t("delivery.creating");

  const TypeLine = () =>
    selectedTransportLabel ? (
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ display: "block", mb: 0.25, fontWeight: 700 }}
      >
        {selectedTransportLabel}
      </Typography>
    ) : null;

  if (isMobile) {
    return (
      <Box
        sx={{
          position: "fixed",
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 1200,
          borderTop: "1px solid",
          borderColor: "divider",
          bgcolor: "background.paper",
          px: 2,
          py: 1.5,
          pointerEvents: "none",
        }}
      >
        <Container maxWidth="sm" sx={{ px: 0, pointerEvents: "auto" }}>
          <Stack direction="row" spacing={1.5} alignItems="center" justifyContent="space-between">
            <Box sx={{ minWidth: 0 }}>
              {/* ✅ Selected type */}
              <TypeLine />

              {/* <Typography variant="caption" color="text.secondary">
                {finalPriceLabel}
              </Typography> */}
              <Typography variant="h6" sx={{ fontWeight: 800, lineHeight: 1.1 }}>
                {estimatedPrice ? `€${estimatedPrice}` : "—"}
              </Typography>
            </Box>

            <Button
              variant="contained"
              onClick={onSubmit}
              disabled={!canSubmit || submitting}
              endIcon={
                submitting ? (
                  <CircularProgress size={18} color="inherit" />
                ) : (
                  <ArrowRight size={18} />
                )
              }
              sx={{ borderRadius: 2, minWidth: 160, flexShrink: 0 }}
            >
              {submitting ? finalSubmittingLabel : finalSubmitLabel}
            </Button>
          </Stack>
        </Container>
      </Box>
    );
  }

  // Desktop
  return (
    <Box
      sx={{
        position: "fixed",
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1200,
        py: 1.25,
        pointerEvents: "none",
      }}
    >
      <Container maxWidth="sm" sx={{ pointerEvents: "auto" }}>
        <Card
          variant="outlined"
          sx={{
            borderRadius: 3,
            boxShadow: 2,
            px: 1.5,
            py: 1.25,
          }}
        >
          <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
            <Box sx={{ minWidth: 0 }}>
              {/* ✅ Selected type */}
              <TypeLine />

              {/* <Typography variant="caption" color="text.secondary">
                {finalPriceLabel}
              </Typography> */}
              <Typography variant="h6" sx={{ fontWeight: 900, lineHeight: 1.1 }}>
                {estimatedPrice ? `€${estimatedPrice} ${t("delivery.vat")}` : "—"}
              </Typography>
            </Box>

            <Button
              variant="contained"
              onClick={onSubmit}
              disabled={!canSubmit || submitting}
              endIcon={
                submitting ? (
                  <CircularProgress size={18} color="inherit" />
                ) : (
                  <ArrowRight size={18} />
                )
              }
              sx={{ borderRadius: 2, minWidth: 180, flexShrink: 0 }}
            >
              {submitting ? finalSubmittingLabel : finalSubmitLabel}
            </Button>
          </Stack>
        </Card>
      </Container>
    </Box>
  );
};
